<script>
export default {
    name: "SimpleContratTemplateFilter",
    props: {
        filter: Object,
    }
}
</script>

<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="6" md="2">
                <w-text-field
                    v-model="filter.name"
                    :label="`${$t('common.name')}`"
                ></w-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
                <w-autocomplete
                    v-model="filter.archive"
                    :items="[{id: false, name: $t('common.in_progress')}, {id: true, name: $t('common.archive')},]"
                    :label="$t('common.state')"
                ></w-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>